import React from "react";
import Datepicker from "../../components/Datepicker";
export const InputForm = ({
  onChange,
  onBlur,
  title,
  type,
  value,
  star,
  pattern,
  errMsg,
  maxLength,
  counter = false,
  disabled = false,
  placeholder,
  dateFormat,
  id,
  prefix,
  name,
  formTitleFontSize,
  minimumYear
}) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-title">
          {title}
          {star ? <span style={{ color: "red" }}> *</span> : ""}
        </div>
        {type !== "date" ? (
          <div className={"input-text-wrapper" + (prefix && type === "tel" ? " input-text-wrapper--tel" : "")}>
            {prefix && type === "tel" && <span className="input-text-prefix">{prefix}</span>}
            <input
              pattern={pattern}
              type={type}
              className={
                "input-text" +
                (errMsg ? " input--error" : "") +
                (counter && maxLength ? " input--with-counter" : "") +
                (disabled ? " input--disabled" : "")
              }
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              maxLength={maxLength}
              disabled={disabled}
              placeholder={placeholder}
              name={name}
            ></input>
            {counter && maxLength && <span className="input-text-counter">{maxLength - value.length}</span>}
          </div>
        ) : (
          <Datepicker
            onChange={onChange}
            onBlur={onBlur}
            pattern={pattern}
            value={value}
            hasError={!!errMsg}
            dateFormat={dateFormat}
            disabled={disabled}
            id={id}
            placeholder={placeholder}
            minimumYear={minimumYear}
          ></Datepicker>
        )}
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 10px 0 20px 0;
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "16px"};
          color: #404040;
          line-height: 19px;
          font-weight: Bold;
          margin-bottom: 8px;
        }
        .input-text {
          border: 0;
          min-width: 0;
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          color: #000;
          padding: 0.75rem 1.5rem;
          -webkit-appearance: unset;
          border: 1px solid #fff;
          font-size: 16px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          border-radius: 8px;
          position: relative;
        }
        .input-text-prefix {
          font-size: 16px;
          font-weight: bold;
          color: #000;
          margin-right: 8px;
          padding: 2px 0 0;
        }
        .input-text-wrapper--tel .input-text {
          padding: 0.75rem;
        }
        .input-text:focus {
          font-weight: bold;
        }
        .input--error {
          border: 1px solid var(--color-red);
        }
        .input--with-counter {
          padding-right: 2.5rem;
        }
        .input-text:disabled {
          background-color: #f4f4f4;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          border: none;
          cursor: not-allowed;
          color: #7b7b7b;
        }
        .input-text-wrapper {
          display: flex;
          align-items: center;
          position: relative;
        }
        .input-text-counter {
          position: absolute;
          right: 0;
          background-color: lightgray;
          padding: 3px;
          margin: 0 5px;
          font-size: 11px;
          border-radius: 3px;
        }
        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};
export const SelectForm = ({
  data,
  onChange,
  onBlur,
  value,
  type,
  title,
  star,
  errMsg,
  disabled = false,
  keyModifier,
  name,
  formTitleFontSize
}) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-title">
          {title}
          {star ? <span style={{ color: "red" }}> *</span> : ""}
        </div>
        <div className="input-select-wrapper">
          <select
            type={type}
            className={"input-select" + (errMsg ? " input--error" : "")}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            name={name}
          >
            {data && Array.isArray(data)
              ? data.map((i) => (
                  <option key={i + keyModifier} value={i}>
                    {i}
                  </option>
                ))
              : Object.keys(data).map((value, key) => (
                  <option key={value + keyModifier} value={data[value]}>
                    {value}
                  </option>
                ))}
          </select>
        </div>
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 10px 0 20px 0;
        }
        .input-select-wrapper {
          display: flex;
          position: relative;
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "16px"};
          color: #404040;
          line-height: 19px;
          font-weight: Bold;
          margin-bottom: 8px;
        }
        .input-select {
          border: 0;
          min-width: 0;
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          color: #000;
          padding: 0.75rem 1.5rem;
          -webkit-appearance: unset;
          border: 1px solid #fff;
          font-size: 16px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          border-radius: 8px;
          background: url(https://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat;
          -webkit-appearance: none;
          background-position-y: 1rem;
          background-position-x: 98%;
        }
        .input--error {
          border: 1px solid var(--color-red);
        }
        .input-select:disabled {
          background-color: #f4f4f4;
          cursor: not-allowed;
          border: none;
          color: #7b7b7b;
        }
        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};
export const CheckBox = ({
  title,
  onChange,
  onBlur,
  value,
  checked,
  errMsg,
  margin,
  formTitleFontSize,
  formTitleFontColor
}) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-checkbox-wrapper">
          <div className="input-checkmark-wrapper">
            <input
              type="checkbox"
              className={"input-checkbox" + (errMsg ? " input--error" : "")}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              checked={checked}
            />
            <span className="input-checkmark"></span>
          </div>
          <div className="input-title">{title}</div>
        </div>
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          margin: ${margin ? margin : ""};
        }
        .input-checkbox-wrapper {
          display: flex;
          justify-content: flex-start;
          margin: 10px 0 0;
          align-items: center;
        }
        .input-checkmark-wrapper {
          position: relative;
          height: 24px;
        }
        .input-checkmark {
          position: absolute;
          border: 2px solid #e11931;
          width: 24px;
          height: 24px;
          left: 0;
          top: 0;
          background-color: white;
        }
        .input-checkbox {
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          opacity: 0;
          z-index: 1;
          cursor: pointer;
        }
        .input-checkbox:checked ~ .input-checkmark {
          background-color: #e11931;
          text-align: center;
        }
        .input-checkbox:checked ~ .input-checkmark::after {
          content: "${"\\2713"}";
          color: white;
        }
        .input--error {
          border: 1px solid var(--color-red);
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "15px"};
          color: ${formTitleFontColor ? formTitleFontColor : "var(--color-gray)"};
          line-height: 19px;
          margin-left: 40px;
        }
        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
          .input-checkbox {
            margin: 1px 16px 0 0;
            height: 15px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};
export const RadioGroup = ({ title, onChange, onBlur, value, errMsg, name, radioData, formTitleFontSize }) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-radio-wrapper">
          <div className="input-title">{title}</div>
          <div className="input-radio-item-wrapper">
            {radioData && Array.isArray(radioData)
              ? radioData.map((val, key) => {
                  return (
                    <label className={"input-radio" + (value === val ? " input-radio--selected" : "")} key={val}>
                      {val}
                      <input
                        type="radio"
                        name={name}
                        value={val}
                        onChange={onChange}
                        onBlur={onBlur}
                        checked={value === val}
                      />
                      <span className="input-radio-checkmark"></span>
                    </label>
                  );
                })
              : Object.keys(radioData).map((val, key) => {
                  return (
                    <label
                      className={"input-radio" + (value === radioData[val] ? " input-radio--selected" : "")}
                      key={val}
                    >
                      {val}
                      <input
                        type="radio"
                        name={name}
                        value={radioData[val]}
                        onChange={onChange}
                        onBlur={onBlur}
                        checked={value === val}
                      />
                      <span className="input-radio-checkmark"></span>
                    </label>
                  );
                })}
          </div>
        </div>
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 10px 0 20px 0;
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "16px"};
          color: #404040;
          line-height: 19px;
          font-weight: Bold;
          margin-bottom: 8px;
        }
        .input--error {
          border: 1px solid var(--color-red);
        }
        .input-radio {
          border: 1px solid #7b7b7b;
          border-radius: 2px;
          padding: 4px 8px;
          padding-left: 36px;
          margin-right: 8px;
          position: relative;
          cursor: pointer;
        }
        .input-radio-item-wrapper {
          display: flex;
          flex-wrap: wrap;
        }
        .input-radio--selected {
          background-color: #fce8ea;
          color: #e11931;
          border-color: #e11931;
        }
        .input-radio-checkmark {
          position: absolute;
          top: 24%;
          left: 8%;
          height: 15px;
          width: 15px;
          border: 1px solid #7b7b7b;
          border-radius: 50%;
        }
        .input-radio-checkmark::after {
          content: "";
          top: 24%;
          left: 8%;
          position: absolute;
          display: none;
        }
        /* hide input radio */
        .input-radio input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
        }
        .input-radio--selected .input-radio-checkmark::after {
          display: block;
        }
        .input-radio--selected .input-radio-checkmark {
          display: block;
          border-color: #e11931;
        }
        .input-radio .input-radio-checkmark::after {
          top: 3px;
          left: 3px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #e11931;
        }
        .input-radio-label {
          margin-left: 20px;
          color: #7b7b7b;
        }
        .input-radio:disabled {
          background-color: #f4f4f4;
          cursor: not-allowed;
          border: none;
          color: #7b7b7b;
        }
        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
          .input-radio {
            margin: 4px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export const InputFormWrapper = ({ title, star, errMsg, formTitleFontSize, children }) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-title">
          {title}
          {star ? <span style={{ color: "red" }}> *</span> : ""}
        </div>
        {children}
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 10px 0 20px 0;
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "16px"};
          color: #404040;
          line-height: 19px;
          font-weight: Bold;
          margin-bottom: 8px;
        }

        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export const TextArea = ({
  onChange,
  onBlur,
  title,
  value,
  star,
  errMsg,
  maxLength,
  disabled = false,
  placeholder,
  name,
  formTitleFontSize,
  rows,
  cols
}) => {
  return (
    <React.Fragment>
      <div className="form-input">
        <div className="input-title">
          {title}
          {star ? <span style={{ color: "red" }}> *</span> : ""}
        </div>
        <div className="input-textarea-wrapper">
          <textarea
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={maxLength}
            disabled={disabled}
            placeholder={placeholder}
            name={name}
            className={"input-textarea" + (errMsg ? " input--error" : "") + (disabled ? " input--disabled" : "")}
            cols={cols}
            rows={rows}
          ></textarea>
        </div>
        <div className="error-msg">{errMsg}</div>
      </div>
      <style jsx>{`
        .error-msg {
          color: var(--color-red);
          text-align: right;
          font-size: 12px;
        }
        .form-input {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 10px 0 20px 0;
        }
        .input-title {
          font-size: ${formTitleFontSize ? formTitleFontSize : "16px"};
          color: #404040;
          line-height: 19px;
          font-weight: Bold;
          margin-bottom: 8px;
        }
        .input-textarea {
          border: 0;
          min-width: 0;
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          color: #000;
          padding: 0.75rem 1.5rem;
          -webkit-appearance: unset;
          border: 1px solid #fff;
          font-family: "Roboto";
          font-size: 16px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          border-radius: 8px;
          position: relative;
          min-height: 150px;
        }
        .input-text:focus {
          font-weight: bold;
        }
        .input--error {
          border: 1px solid var(--color-red);
        }
        .input-text:disabled {
          background-color: #f4f4f4;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.4);
          border: none;
          cursor: not-allowed;
          color: #7b7b7b;
        }
        .input-textarea-wrapper {
          display: flex;
          align-items: center;
          position: relative;
        }
        @media only screen and (max-width: 600px) {
          .input-title {
            font-size: 12px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};
